var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fiche-biblio" },
    [
      _c(
        "v-expansion-panel",
        { attrs: { expand: "" } },
        _vm._l(_vm.biblios, function(biblio) {
          return _c(
            "v-expansion-panel-content",
            { key: biblio.id },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("collections_bookmark")
                  ]),
                  _vm._v("\n        " + _vm._s(biblio.title) + "\n        "),
                  _c(
                    "span",
                    { staticClass: "caption grey--text text--darken-1" },
                    [
                      _vm._v(
                        "\n          (\n          " +
                          _vm._s(
                            _vm.$tc("subLibraries", biblio.subs.length, {
                              count: biblio.subs.length
                            })
                          ) +
                          "\n          " +
                          _vm._s(
                            _vm.$tc("sentences", biblio.sentences.length, {
                              count: biblio.sentences.length
                            })
                          ) +
                          "\n          )\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "grey lighten-3 px-1" },
                    [
                      biblio.subs.length
                        ? _c(
                            "v-expansion-panel",
                            { attrs: { expand: "" } },
                            _vm._l(biblio.subs, function(sub) {
                              return _c(
                                "v-expansion-panel-content",
                                { key: sub.id, attrs: { avatar: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("book")]
                                      ),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(sub.title) +
                                          "\n                "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "caption grey--text text--darken-1"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  (" +
                                              _vm._s(
                                                _vm.$tc(
                                                  "sentences",
                                                  sub.sentences.length,
                                                  {
                                                    count: sub.sentences.length
                                                  }
                                                )
                                              ) +
                                              ")\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass:
                                            "grey lighten-3 pl-1 pr-2"
                                        },
                                        [
                                          sub.sentences.length
                                            ? _c(
                                                "v-list",
                                                {
                                                  attrs: {
                                                    "two-line": "",
                                                    dense: "",
                                                    subheader: ""
                                                  }
                                                },
                                                _vm._l(sub.sentences, function(
                                                  phrase
                                                ) {
                                                  return _c(
                                                    "v-list-tile",
                                                    {
                                                      key: phrase.id,
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.status ===
                                                          "offline"
                                                            ? ";"
                                                            : _vm.putMessage(
                                                                phrase.title
                                                              )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-content",
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "truncate"
                                                                )(
                                                                  phrase.title,
                                                                  120
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-action",
                                                        [
                                                          _vm.checkRouteSendChat
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "secondary--text",
                                                                    icon: "",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.sendMessage(
                                                                        phrase.title
                                                                      )
                                                                    },
                                                                    mouseover: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = true
                                                                    },
                                                                    mouseleave: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = false
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "send"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      _vm.status ===
                                                                      "offline"
                                                                        ? "grey--text"
                                                                        : "secondary--text",
                                                                    icon: "",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.sendMessage(
                                                                        phrase.title
                                                                      )
                                                                    },
                                                                    mouseover: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = true
                                                                    },
                                                                    mouseleave: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = false
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "send"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "grey lighten-3 px-1" },
                    [
                      biblio.sentences.length
                        ? _c(
                            "v-list",
                            {
                              attrs: {
                                "two-line": "",
                                dense: "",
                                subheader: ""
                              }
                            },
                            _vm._l(biblio.sentences, function(phrase) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: phrase.id,
                                  on: {
                                    click: function($event) {
                                      _vm.status === "offline"
                                        ? ";"
                                        : _vm.putMessage(phrase.title)
                                    }
                                  }
                                },
                                [
                                  _c("v-list-tile-content", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("truncate")(phrase.title, 120)
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _vm.checkRouteSendChat
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "secondary--text",
                                                icon: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.sendMessage(
                                                    phrase.title
                                                  )
                                                },
                                                mouseover: function($event) {
                                                  _vm.overMenu = true
                                                },
                                                mouseleave: function($event) {
                                                  _vm.overMenu = false
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("send")])],
                                            1
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color:
                                                  _vm.status === "offline"
                                                    ? "grey--text"
                                                    : "secondary--text",
                                                icon: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.sendMessage(
                                                    phrase.title
                                                  )
                                                },
                                                mouseover: function($event) {
                                                  _vm.overMenu = true
                                                },
                                                mouseleave: function($event) {
                                                  _vm.overMenu = false
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("send")])],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0184e3c8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0184e3c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzFicheBiblioPhrases.vue
// module id = null
// module chunks = 